import React, { useEffect } from "react";
import PropTypes from "prop-types";
import { useStaticQuery, graphql } from "gatsby";

/* eslint-disable */
const ContactForm = ({ html, action }) => {
  const { wp } = useStaticQuery(graphql`
    query {
      wp {
        crbThemeOptions {
          crbSecretKey
          crbSiteKey
        }
      }
    }
  `);

  const message = "";
  async function formSubmit(e) {
    e.preventDefault();
    const frmDiv = this.closest("div");
    const form = this;
    const frmData = new FormData(form);
    /*eslint no-unused-vars: ["error", { "varsIgnorePattern": "grecaptcha" }]*/
    const token = await grecaptcha.execute(wp.crbThemeOptions.crbSiteKey, {
      action: "submit",
    });
    frmData.delete("_wpcf7_recaptcha_response");
    frmData.append("_wpcf7_recaptcha_response", token);

    const req = new XMLHttpRequest();
    req.open("POST", action, true);
    req.onload = () => {
      if (req.status == 200) {
        const response = JSON.parse(req.response);
        form
          .querySelectorAll(".form-input-required-message")
          .forEach((errMsg) => {
            errMsg.remove();
          });
        form.querySelectorAll("span.form-input-required").forEach((errSpan) => {
          errSpan.classList.remove("form-input-required");
        });

        if (response.status === "validation_failed") {
          response.invalid_fields.forEach((field) => {
            const element = form.querySelector(field.into);
            if (!element.classList.contains("form-input-required")) {
              element.classList.add("form-input-required");
              element.insertAdjacentHTML(
                "afterend",
                `<p class="form-input-required-message">${field.message}</p>`
              );
            }
          });
        } else if (response.status === "mail_sent") {
          frmDiv.querySelectorAll(".form-message").forEach((element) => {
            element.remove();
          });
          frmDiv.insertAdjacentHTML(
            "afterend",
            `<p class="form-message-success">${response.message}</p>`
          );
          frmDiv.remove();
        } else {
          frmDiv.querySelectorAll(".form-message").forEach((element) => {
            element.remove();
          });
          frmDiv.insertAdjacentHTML(
            "afterend",
            `<p class="form-message">${response.message}</p>`
          );
        }
      } else {
      }
    };

    req.send(frmData);
  }

  useEffect(() => {
    document
      .querySelector('form[class~="wpcf7-form"]')
      .addEventListener("submit", formSubmit);
  }, []);

  return (
    <>
      <div className="contactForm" dangerouslySetInnerHTML={{ __html: html }} />
      {message && <div style={{ color: "red" }}>{message}</div>}
    </>
  );
};

export default ContactForm;

ContactForm.propTypes = {
  action: PropTypes.string.isRequired,
  html: PropTypes.string.isRequired,
};
